/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';

class Color {
  public name: string;
  public code: string;
}

@Injectable({ providedIn: 'root' })
export class AcquisitionChartColorService {
  private readonly schemeColors: Color[] = [
    {
      name: 'Shamrock',
      code: '#28A228',
    },
    {
      name: 'Rose',
      code: '#F43A20',
    },
    {
      name: 'Deep Orange',
      code: '#FF5722',
    },
    {
      name: 'Burnt Orange',
      code: '#D47500',
    },
    {
      name: 'Camo',
      code: '#807D67',
    },
    {
      name: 'Lime Green',
      code: '#03A678',
    },
    {
      name: 'Green',
      code: '#24A159',
    },
    {
      name: 'Teal',
      code: '#00A4A6',
    },
    {
      name: 'Cruising',
      code: '#008DA9',
    },
    {
      name: 'Cyan',
      code: '#638BB3',
    },
    {
      name: 'Blue',
      code: '#2196f3',
    },
    {
      name: 'Pansy',
      code: '#D400D4',
    },
    {
      name: 'Magenta',
      code: '#EB377F',
    },
    {
      name: 'Pink',
      code: '#F06292',
    },
    {
      name: 'Red',
      code: '#DA3A3A',
    },
    {
      name: 'Mauve',
      code: '#D25299',
    },
    {
      name: 'Silver',
      code: '#939393',
    },
    {
      name: 'Khaki',
      code: '#AA8F00',
    },
    {
      name: 'Terracota',
      code: '#E76E3C',
    },
    {
      name: 'Lavender',
      code: '#B381B3',
    },
    {
      name: 'Black',
      code: '#000000'
    }
  ];

  private assignedColors: { [channel: string]: string } = {
    'CT_WEIGHT': 'Green',
    'CIRC_PRESS': 'Red',
    'WH_PRESS': 'Blue',
    'CT_CORR_DEPTH': 'Black',
    'VOLUME_PUMP1': 'Blue',
    'N2_VOLUME': 'Red',
    'cvw_sc': 'Blue',
    'cvo_sc': 'Green',
    'cvg_sc': 'Red',
    'SOLIDS': 'Khaki'
  };

  public getColorsForChannels(channelNames: string[]): string[] {
    const availableColors = this.schemeColors.map(x => x.name).filter(x => !Object.values(this.assignedColors).includes(x));

    for (const channelName of channelNames) {
      if (!this.assignedColors[channelName]) {
        this.assignedColors[channelName] = availableColors.length > 0 ? availableColors.pop() : 'Black';
      }
    }

    return channelNames.map(x => this.schemeColors.filter(y => y.name === this.assignedColors[x])[0].code);
  }
}
